import { render, staticRenderFns } from "./HyXQ.vue?vue&type=template&id=890fef80&scoped=true"
import script from "./HyXQ.vue?vue&type=script&lang=js"
export * from "./HyXQ.vue?vue&type=script&lang=js"
import style0 from "./HyXQ.vue?vue&type=style&index=0&id=890fef80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890fef80",
  null
  
)

export default component.exports